export default "__VITE_ASSET__a5b2383a__"